// extracted by css-extract-rspack-plugin
export default {"root":"_1maWi5yfmJvZwKkITONhMj","header":"yODBvzENR_AFKwWzVGlol","close":"_3hrpdb9RPua0ZgjtBcRfth","content":"_2LLPKGgoXVOwhvbfdOqWpc"};